































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import LogComponent from '@/shared/log/log.component.vue';

@Component({
  components: {
    LogComponent,
  },
})
export default class BillingInfoModalLog extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop({
    required: true,
  })
  summary!: string[];

  @Prop({
    required: false,
  })
  createdDate!: string;

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }
}
